export const lineHeights = {
  11: '11px',
  13: '13px',
  14: '14px',
  15: '15px',
  16: '16px',
  18: '18px',
  20: '20px',
  22: '22px',
  24: '24px',
  32: '32px',
  36: '36px',
  38: '38px',
  40: '40px',
  48: '48px',
  60: '60px',
  100: '100px',
  200: '200px',
};
